
import { Component, Vue } from "vue-property-decorator";
import { namespace } from "vuex-class";
import { Table } from "@common/src/utils/decorator";
import { formDownload } from "@common/src/utils/tools";
import { addCurrencyUnit } from "@common/src/utils/tools";
import { InjectFunction } from "@common/src/utils/decorator";
import t from "@common/src/i18n/t";
import { OpDefalutQueryStore } from "@common/src/utils/constant";
import StandardFlag from "@common/src/components/scope/standard-flag/index.vue";

const warehouse = namespace("warehouse");
const common_warehouse = namespace("common_warehouse");
const parts = namespace("parts");
const base = namespace("base");
const inventory = namespace("inventory");
const partsCategory = namespace("parts-category");
const management = namespace("management");

@InjectFunction("emptyToLine", "splitThousands", "permit", "permitApp", "appCode")
@Component({ components: { StandardFlag } })
@Table("loadListData")
export default class Parts extends Vue {
  @inventory.Action getPartsInventoryList;
  @parts.Action updateStatus;
  @partsCategory.Action getCategoryList;
  @management.Action getStoreList;
  @base.Action getDictionaryList;
  @parts.Action getPartsBrandList;
  @warehouse.Action getWarehouseList;
  @common_warehouse.Action queryWarehouseShelfTree;
  t = t;
  searchForm = {
    storeCode: "",
    partsName: "",
    warehouseCode: "",
    partsCategoryCode: "",
    brandCode: "",
    findInvEmpty: "0",
    groupByWarehouse: "0",
    alertFlag: "",
    partsCodeArray: [],
    findTemporaryParts: "1",
    shelfCode: "" // 库位Code
  };
  hideCost: boolean = true;
  addCurrencyUnit = addCurrencyUnit;
  sortForm: {};
  partsList: any[] = [];
  get searchList() {
    return [
      ...(this.appCode === "speedbiz-operation"
        ? [
            {
              label: t("v210831.store-name"),
              type: "select-search",
              value: OpDefalutQueryStore.value,
              prop: "storeCode",
              placeholder: t("v210801.please-enter-keyword"),
              selectList: this.storeList,
              searchFun: this.searchStore,
              clearable: false
            }
          ]
        : []),
      {
        label: "parts.name",
        type: "input",
        value: "",
        prop: "partsName"
      },
      {
        label: t("parts.code"),
        type: "input",
        value: "",
        prop: "partsNumber"
      },
      ...(this.appCode === "speedbiz"
        ? [
            {
              label: "setting.brand",
              type: "select",
              value: "",
              prop: "brandCode",
              selectList: this.brandList
            }
          ]
        : []),
      {
        label: "parts.category",
        type: "cascader",
        prop: "partsCategoryCode",
        value: "",
        options: this.categoryList,
        props: {
          label: "categoryName",
          value: "categoryCode"
        }
      },
      ...(this.appCode === "speedbiz"
        ? [
            {
              label: "warehouse.warehouse",
              type: "select",
              value: "",
              selectList: this.warehouseList,
              clearMethod: this.handleSearchWarehouseClear,
              changeMethod: this.handleSearchWarehouseChange,
              prop: "warehouseCode"
            },
            ...(!this.hideShelf
              ? [
                  {
                    label: t("v210.location"),
                    type: "select",
                    value: "",
                    selectList: this.shelfList,
                    prop: "shelfCode",
                    disabled: this.shelfSelectDiasabled,
                    noKeepOld: true
                  }
                ]
              : [])
          ]
        : [])
    ];
  }
  categoryList: any = [];
  warehouseList: any = [];

  brandList: any = [];
  get isShowAlert() {
    return this.$route.query.showAlert === "1";
  }
  get urlPartsCodeArr() {
    if (this.$route.query.partCodeArr) {
      return (this.$route.query.partCodeArr as string).split(",");
    } else {
      return undefined;
    }
  }
  created() {
    if (this.permitApp("speedbiz-operation")) {
      this.searchForm.storeCode = OpDefalutQueryStore.value;
    }
    this.init();
  }
  handleExportData() {
    if (!this.onlyShowZeroStock) {
      this.searchForm.findInvEmpty = "1";
    } else {
      this.searchForm.findInvEmpty = "0";
    }
    if (this.onlyShowStockAlert) {
      this.searchForm.alertFlag = "1";
    } else {
      this.searchForm.alertFlag = "";
    }
    if (this.hideShelf) {
      this.searchForm.groupByWarehouse = "1";
    } else {
      this.searchForm.groupByWarehouse = "0";
    }
    if (this.appCode === "speedbiz") {
      formDownload(`${window.API_URL}/inventory/qtyExport`, this.searchForm);
    } else {
      formDownload(`${window.API_URL}/opInventory/qtyExport`, this.searchForm);
    }
  }
  warehouseShelfMap: any = {};
  async init() {
    if (this.isShowAlert) {
      this.searchForm.alertFlag = "1";
      this.onlyShowStockAlert = true;
    }
    if (this.urlPartsCodeArr) {
      this.searchForm.partsCodeArray = this.urlPartsCodeArr;
    }
    this.loadListData();

    if (this.appCode === "speedbiz") {
      this.getBrandList();
      this.queryWarehouseShelfTree({
        pageNum: 1,
        pageSize: 100
      }).then(data => {
        let list = this.$safeValue(data, "data.warehouseList", []);
        let warehouseList = [];
        list.forEach(item => {
          warehouseList.push({
            label: item.warehouseName,
            value: item.warehouseCode
          });
          if (!this.warehouseShelfMap[item.warehouseCode]) {
            this.warehouseShelfMap[item.warehouseCode] = item.shelfList;
          }
        });
        this.warehouseList = warehouseList;
      });
    }

    const data = await this.getCategoryList();
    this.categoryList = this.addLeafFlag(this.$safeValue(data, "data", []));
  }
  handleLinkPartsDetail(row) {
    if (this.appCode === "speedbiz") {
      let { href } = this.$router.resolve({
        path: `/setting/parts-edit/${row.partsCode}`
      });
      window.open(href, "_blank");
    }
  }
  getBrandList() {
    this.getPartsBrandList().then(data => {
      this.brandList = this.$safeValue(data, "data.list", []).map(item => ({
        label: item.brandName,
        value: item.brandCode
      }));
    });
  }
  inventoryQty: any = "";
  inventoryAmount: any = "";
  @Table.LoadDataMethod()
  loadListData() {
    if (!this.onlyShowZeroStock) {
      this.searchForm.findInvEmpty = "1";
    } else {
      this.searchForm.findInvEmpty = "0";
    }
    if (this.onlyShowStockAlert) {
      this.searchForm.alertFlag = "1";
    } else {
      this.searchForm.alertFlag = "";
    }
    if (this.hideShelf) {
      this.searchForm.shelfCode = "";
      this.searchForm.groupByWarehouse = "1";
    } else {
      this.searchForm.groupByWarehouse = "0";
    }
    return this.getPartsInventoryList({
      // status: "9",
      findTemporaryParts: "1",
      orderItems: this.mix_sortParams,
      ...this.searchForm,
      pageNum: this.mix_pageNum,
      pageSize: this.mix_pageSize,
      partsName: this.searchForm.partsName
    }).then(data => {
      this.partsList = this.$safeValue(data, "data.list", []);
      this.inventoryQty = data.data.inventoryQty;
      this.inventoryAmount = data.data.inventoryAmount;
      return data;
    });
  }
  addLeafFlag(list) {
    if (!list) return;
    const f = function (list) {
      list.forEach(item => {
        if (!item.children || item.children.length < 1) {
          delete item.children;
        } else {
          f(item.children);
        }
      });
    };
    f(list);
    return list;
  }
  handleSearch(data, type) {
    if (type === "reset") {
      this.shelfSelectDiasabled = true;
    }
    this.searchForm.partsCodeArray = [];
    this.mix_pageNum = 1;
    data.forEach(item => {
      if (item.prop) {
        if (item.prop === "partsCategoryCode") {
          this.searchForm[item.prop] = item.value[item.value.length - 1] || "";
        } else {
          this.searchForm[item.prop] = item.value;
        }
      }
    });
    if (this.permitApp("speedbiz-operation") && !this.searchForm.storeCode) {
      return this.$message.error(t("v210831.please-select-a-store"));
    }
    this.loadListData();
  }
  onlyShowStockAlert: boolean = false;
  onlyShowZeroStock: boolean = false;
  hideShelf: boolean = false;
  storeList: any = [OpDefalutQueryStore];
  searchStore(val = "") {
    this.getStoreList({
      pageNum: 1,
      pageSize: 10,
      storeName: val
    }).then(data => {
      this.storeList = data.data.list
        ? data.data.list.map(item => {
            item.label = item.storeName;
            item.value = item.storeCode;
            return item;
          })
        : [];
    });
  }
  handleBtnFilterChagne() {
    this.mix_pageNum = 1;

    this.loadListData();
  }
  shelfList: any = [];
  shelfSelectDiasabled: boolean = true;
  handleSearchWarehouseChange(val) {
    this.shelfSelectDiasabled = false;
    this.searchForm.shelfCode = "";
    this.shelfList = (this.warehouseShelfMap[val] || []).map(item => {
      item.label = item.shelfDesc;
      item.value = item.shelfCode;
      return item;
    });
  }
  handleSearchWarehouseClear() {
    this.shelfSelectDiasabled = true;
  }
}
